// Web-compatible version - simplified for URL strings and File objects
interface WebAsset {
  uri?: string
  name?: string
  type?: string
  size?: number
}

export default class ImageAssetOrUri {
  asset?: WebAsset | File
  existingImageUri?: string

  get isAsset() {
    return !!this.asset
  }

  get uri(): string {
    if (this.isAsset) {
      if (this.asset instanceof File) {
        return URL.createObjectURL(this.asset)
      }
      return (this.asset as WebAsset)?.uri ?? ''
    } else {
      return this.existingImageUri ?? ''
    }
  }

  get key(): string {
    return this.uri
  }

  constructor(data: { asset?: WebAsset | File; existingImageUri?: string }) {
    this.asset = data.asset
    this.existingImageUri = data.existingImageUri

    if (!this.asset && !this.existingImageUri) {
      throw new Error('ImageAssetOrUri requires either an asset or a uri')
    }
  }
}
